export const OPT_IN_EVENT = "RCB/OptIn";